module.exports = __webpack_public_path__ + "img/circle_ok.e973f447.svg";